import { PersistentStorageStrategyFactory } from './factories';
import {
  localStorageStrategy,
  cookieStorageStrategyFactory
} from './strategies';

const resolver = new PersistentStorageStrategyFactory();

resolver.register(localStorageStrategy);
resolver.register(cookieStorageStrategyFactory('rbfep'));

export const storage = resolver.getStrategy().storageInstance();
